import classNames from "classnames"
import React from "react"

import { Title2, Title3 } from "@bounce/design-system"

import type { StoreGridProps } from "./StoreGrid"
import { StoreGrid } from "./StoreGrid"
import { useSectionViewed } from "@/hooks/useSectionViewed"

type StoreGridSectionProps = Pick<
  StoreGridProps,
  "className" | "from" | "path" | "searchQuery" | "stores" | "renderStructuredData" | "featuredPoi" | "maxStores"
> & {
  sectionViewedMeta?: object
  subtitle?: React.ReactNode
  title?: React.ReactNode
  gridClassName?: string
}

export const StoreGridSection = ({
  className,
  gridClassName,
  from,
  path,
  searchQuery,
  sectionViewedMeta,
  stores,
  subtitle,
  title,
  featuredPoi,
  renderStructuredData = true,
  maxStores,
}: StoreGridSectionProps) => {
  const { sectionRef } = useSectionViewed({ name: "StoreGrid", meta: sectionViewedMeta })

  return (
    <section ref={sectionRef} className={classNames("mx-auto flex w-full max-w-screen-xl flex-col", className)}>
      <div className="px-6">
        {!!title && <Title2 className="break-words">{title}</Title2>}
        {!!subtitle && <Title3 className="!paragraph1 mt-2 text-neutral-800">{subtitle}</Title3>}
      </div>
      <StoreGrid
        className={gridClassName}
        featuredPoi={featuredPoi}
        from={from}
        maxStores={maxStores}
        path={path}
        renderStructuredData={renderStructuredData}
        searchQuery={searchQuery}
        stores={stores}
      />
    </section>
  )
}
